import { CountdownNextDefragTimeDocument } from "#webapp/src/graphql/__generated__/CountdownNextDefragTime.generated";
import { useQuery } from "@apollo/client";
import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import { DateTime, Duration } from "luxon";
import React, { useEffect, useState } from "react";
import { getFormattedDuration } from "../utils/getFormattedDuration";

export const Countdown = ({ orgId }: { orgId: string }) => {
  const { data, loading, error } = useQuery(CountdownNextDefragTimeDocument, {
    variables: {
      orgId,
    },
  });
  const [_, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((seconds) => seconds + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (loading || error) {
    return null;
  }

  const org = getValue(data?.org, "Org");
  const nextDefragTimeMillis: number | undefined = getValue(org?.nextDefragTime, "DefragTime")
    ?.millis;

  if (!nextDefragTimeMillis) {
    return null;
  }

  const now = DateTime.local();
  const nextDefrag = DateTime.fromMillis(nextDefragTimeMillis);
  const diff = nextDefrag.diff(now, ["days", "hours", "minutes", "seconds", "milliseconds"]); // Specifiying "milliseconds" forces "seconds" to be an integer

  if (now > nextDefrag) {
    // This is can happen if data is stale
    return null;
  }

  const TimeCard = ({ durationDiff }: { durationDiff: Duration }) => {
    const timeDiff = getFormattedDuration(durationDiff);
    return (
      <div className="cw-flex cw-items-center cw-justify-center cw-heading-lg md:cw-heading-2xl">
        {timeDiff.days && (
          <>
            <div className="cw-bg-brand cw-rounded-sm cw-p-1 cw-border cw-border-solid cw-border-brand-emphasis cw-w-[40px]">
              {timeDiff.days}
            </div>
            <div className="cw-px-1"> : </div>
          </>
        )}
        <div className="cw-bg-brand cw-rounded-sm cw-p-1 cw-border cw-border-solid cw-border-brand-emphasis cw-w-[40px]">
          {timeDiff.hours}
        </div>
        <div className="cw-px-1"> : </div>
        <div className="cw-bg-brand cw-rounded-sm cw-p-1 cw-border cw-border-solid cw-border-brand-emphasis cw-w-[40px]">
          {timeDiff.minutes}
        </div>
        <div className="cw-px-1"> : </div>
        <div className="cw-bg-brand cw-rounded-sm cw-p-1 cw-border cw-border-solid cw-border-brand-emphasis cw-w-[40px]">
          {timeDiff.seconds}
        </div>
      </div>
    );
  };

  return (
    <div className="cw-hidden md:cw-flex cw-items-center cw-justify-center cw-w-full cw-mt-6 cw-flex-wrap">
      <div className="cw-pr-2 cw-heading-lg md:cw-heading-2xl">
        Next daily optimization happens in
      </div>
      <TimeCard durationDiff={diff} />
    </div>
  );
};
